import { ComponentRef, Injectable, ViewContainerRef, signal } from '@angular/core';
import { SvgComponent } from '@app/components/svg/svg.component';
import { XMLElementBaseComponent } from './base';
import { XMLComponentResolverService } from './resolver.service';

@Injectable({
  providedIn: 'root',
})
export class ChildRendererService {
  dbId: string | undefined;
  provider!: string;
  svgComponents = signal<SvgComponent[]>([]);

  constructor(private resolver: XMLComponentResolverService) {}

  setDbId(dbId: string) {
    this.dbId = dbId;
  }

  setProvider(provider: string) {
    this.provider = provider;
  }

  registerSvgElement(svgElement: SvgComponent) {
    this.svgComponents.update((current) => [...current, svgElement]);
  }

  renderChildren(children: any[], viewContainer: ViewContainerRef): ComponentRef<XMLElementBaseComponent>[] {
    const componentRefs: ComponentRef<XMLElementBaseComponent>[] = [];

    children.forEach((child) => {
      const componentType = this.resolver.getComponent(child.tag);
      if (componentType) {
        try {
          const componentRef = viewContainer.createComponent(componentType);
          componentRef.instance.data = child;
          componentRef.instance.dbId = this.dbId;
          componentRef.instance.provider = this.provider;
          componentRefs.push(componentRef);
        } catch (error) {
          console.error('Failed to render child:', child.tag, error);
        }
      }
    });

    return componentRefs;
  }

  cleanup() {
    this.dbId = undefined;
    this.provider = '';
    this.svgComponents.set([]);
  }
}
